import { MannequinProvider } from './context/MannequinContext';
import AIGenerationHistory from './components/AIGeneration/AIGenerationHistory';

export const AIGenerationHistoryPage = () => {
    return (
        <MannequinProvider>
            <AIGenerationHistory />
        </MannequinProvider>
    );
};

